import { motion } from 'framer-motion';
import { Helmet } from "react-helmet";
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import useScrollToTop from './ScrollToTop';
import OsiligiSupportForm from './OsiligiSupportForm.jsx'; 
import { useState } from 'react';
import './Osiligi.css'; // You’ll need to update this CSS too

const galleryImages = [
  "/images/lab.jpg",
  "/images/mentorship.jpg",
  "/images/IMG-20250703-WA0013 - Copy.jpg",
  "/images/communityinvolvement.jpg",
  "/images/dentist.jpg",
  "/images/img_6847.jpg",
];

const Osiligi = () => {
  useScrollToTop();
  const { t } = useTranslation('osiligi');
  const [showSupportForm, setShowSupportForm] = useState(false);

  const handleOpenSupport = () => setShowSupportForm(true);
  const handleCloseSupport = () => setShowSupportForm(false);

  return (
    <motion.div
      className="osg-page"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Osiligi Medical Clinic | Community Impact by Olenini Safaris</title>
        <meta name="description" content="The Osiligi Medical Clinic is a community project by Olenini Safaris in Narok County, Kenya. Supported by volunteers, it provides essential healthcare services to local communities." />
        <meta name="keywords" content="Osiligi clinic, Narok medical project, Olenini community clinic, Kenya volunteer medical project, safari company impact, social responsibility Kenya" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://oleninisafaris.com/osiligi" />
      </Helmet>

      {/* Hero Section */}
      <section className="osg-hero">
        <img
          src="/images/img_6893.jpg"
          alt="Osiligi Reserve"
          className="osg-hero__image"
        />
        <div className="osg-hero__text">
          <h1>{t('heroText.title')}</h1>
          <p>{t('heroText.subtitle')}</p>
        </div>
      </section>

      {/* About Section */}
      <div className="osg-about-card">
        <p><Trans i18nKey="aboutOsiligi.paragraph1" ns="osiligi" components={{ strong: <strong /> }} /></p>
        <p><Trans i18nKey="aboutOsiligi.paragraph2" ns="osiligi" components={{ strong: <strong /> }} /></p>
        <p>{t('aboutOsiligi.paragraph3', { ns: 'osiligi' })}</p>
        <p>{t('aboutOsiligi.paragraph4', { ns: 'osiligi' })}</p>
        <p>{t('aboutOsiligi.paragraph5', { ns: 'osiligi' })}</p>
        <p><Trans i18nKey="aboutOsiligi.paragraph6" ns="osiligi" components={{ strong: <strong /> }} /></p>

        <div className="osg-button-group">
          <Link to="/contact?source=osiligimedicalfoundation" className="osg-btn osg-btn--primary">
            Plan Your Safari Today
          </Link>
          <button onClick={handleOpenSupport} className="osg-btn osg-btn--support">
            Support Osiligi Foundation
          </button>
        </div>
      </div>

      {/* Gallery */}
      <section className="osg-gallery">
        <h2>{t('galleryHeading')}</h2>
        <div className="osg-gallery__grid">
          {galleryImages.map((img, i) => (
            <div className="osg-gallery__item" key={i}>
              <img src={img} alt={`Gallery ${i + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      {/* Medical Camp Report */}
      <section className="osg-report">
        <h2 className="osg-report__title osg-section-heading">{t('report.title')}</h2>
        <p className="osg-report__date">{t('report.date')}</p>

        <div className="osg-report__content">
          <table className="osg-report__table">
            <thead>
              <tr>
                <th>{t('report.table.headers.service')}</th>
                <th>{t('report.table.headers.details')}</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(t('report.table.rows', { returnObjects: true })).map((key, i) =>
                i % 2 === 0 ? (
                  <tr key={i}>
                    <td>{t(`report.table.rows.${key}`)}</td>
                    <td>{t(`report.table.rows.${key}Details`)}</td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>

          <div className="osg-report__note">
            <p><strong>{t('report.note')}</strong></p>
          </div>

          <div className="osg-report__thankyou">
            <p><Trans i18nKey="report.thankyou.p1" ns="osiligi" /></p>
            <p><Trans i18nKey="report.thankyou.p2" ns="osiligi" components={[<strong />]} /></p>
            <p><Trans i18nKey="report.thankyou.p3" ns="osiligi" components={[<em />]} /></p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="osg-cta">
        <h3>{t('cta.title')}</h3>
        <p><Trans i18nKey="cta.paragraph" ns="osiligi" /></p>
        <Link to="/contact?source=osiligimedicalfoundation" className="osg-btn osg-btn--primary">
          {t('cta.button')}
        </Link>
      </section>

      {/* Modal Form */}
      {showSupportForm && <OsiligiSupportForm onClose={handleCloseSupport} />}
    </motion.div>
  );
};

export default Osiligi;
